<section class="new-translation" fxLayout fxLayoutAlign="center">
  <form #f="ngForm" (ngSubmit)="onSubmit(f)" autocomplete="off">
    <mat-card >

      <mat-card-title fxLayoutAlign="center" *ngIf="dealerService.dealerData.id"> Edit Dealer</mat-card-title>
      <mat-card-title fxLayoutAlign="center" *ngIf="!dealerService.dealerData.id"> Create Dealer</mat-card-title>
     
      <mat-card-content fxLayout="row" fxLayoutAlign="space-evenly center"  >
        <div>
          <mat-form-field>
            <input type="text" matInput placeholder="Name" [(ngModel)]="dealerService.dealerData.name" name="name"  autocomplete="off" required
                   #Name="ngModel"  />
            <mat-error *ngIf="Name.hasError('required')">Name cannot be empty</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Display Name" [(ngModel)]="dealerService.dealerData.displayName" name="displayName"
                   #DisplayName="ngModel" autocomplete="off"  />
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Location" [(ngModel)]="dealerService.dealerData.location" name="location" required
                   #Location="ngModel" />
            <mat-error *ngIf="Location.hasError('required')">Location cannot be empty</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Display Location" [(ngModel)]="dealerService.dealerData.displayLocation" name="displayLocation"
                   #DisplayLocation="ngModel" />
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Address" [(ngModel)]="dealerService.dealerData.address" name="address"
                   #Address="ngModel" />
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="PostCode" [(ngModel)]="dealerService.dealerData.postCode" name="postCode" required
                   #PostCode="ngModel" />
            <mat-error *ngIf="PostCode.hasError('required')">PostCode cannot be empty</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Distance" [(ngModel)]="dealerService.dealerData.distance" name="distance" required
                   #Distance="ngModel" />
            <mat-error *ngIf="Distance.hasError('required')">Distance cannot be empty</mat-error>
          </mat-form-field>
        </div>
        <div >
         
          <mat-form-field>
            <input type="text" matInput placeholder="MaxCpc" [(ngModel)]="dealerService.dealerData.maxCpc" name="maxCpc" required
                   #MaxCpc="ngModel" />
            <mat-error *ngIf="MaxCpc.hasError('required')">Max CPC  cannot be empty</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Site Links" [(ngModel)]="dealerService.dealerData.siteLinks" name="siteLinks"
                   #SiteLinks="ngModel" />
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Feed Id" [(ngModel)]="dealerService.dealerData.feedId" name="feedId" required
                   #FeedId="ngModel" />
            <mat-error *ngIf="FeedId.hasError('required')">Feed ID cannot be empty</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input type="text" matInput placeholder="Email" [(ngModel)]="dealerService.dealerData.email" name="email"
                   #Email="ngModel" />
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Key Contact" [(ngModel)]="dealerService.dealerData.maxBidprice" name="maxBidprice"
                   #MaxBidprice="ngModel" />
          </mat-form-field>
          <mat-form-field>
            <mat-select placeholder="Status" [(ngModel)]="dealerService.dealerData.status" name="status"  #Status="ngModel" >
              <mat-option *ngFor="let ds of dealerService.dealerStatus" [value]="ds.id">
                {{ds.statusname}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <input type="text" matInput placeholder="Parent Dealer" [(ngModel)]="dealerService.dealerData.parentDealerid" name="parentDealerid"
                   #ParentDealerId="ngModel" />
          </mat-form-field>

        </div>
      
       
      </mat-card-content>
      <mat-card-actions fxLayoutAlign="center">
        <button type="submit" [disabled]="f.invalid" mat-raised-button color="primary">Submit</button>
        <button  type="button" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</section>
